module.exports = __webpack_public_path__ + "static/media/pdf-icon.c73874b5.svg";